<div class="assistant-bullets">
  <div class="assistant-sub-header">
    {{ assistantContent.preferences }}
  </div>
</div>
